<template>
  <div class="news-headlines-detail">
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>如何申请组考单位</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="groupdetial-wrapper">
            <div class="message">
                <div class="message-top flex-column-center">
                <p>如果你想申请组考单位，请在下方留言或拨打电话联系我们</p>
                <p class="flex-align-center"><span></span></p>
                </div>
                <div class="message-box flex-align-between">
                <div class="message-box-left">
                    <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item>
                        <el-row  type="flex" class="row-bg" justify="space-between" :gutter="30">
                        <el-col :span="16">
                            <el-input placeholder="姓名" v-model="form.name"></el-input>
                        </el-col>
                        <el-col :span="16">
                            <el-input placeholder="手机号码" v-model="form.phone"></el-input>
                        </el-col>
                        </el-row>
                    </el-form-item>

                    <el-form-item >
                        <el-input placeholder="邮箱" v-model="form.address"></el-input>
                    </el-form-item>
                    <el-form-item >
                        <el-input rows='6' type="textarea" placeholder="留言......." v-model="form.comment"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-row type="flex" class="row-bg" justify="end">
                        <div class="button">
                            <div class="button-left pointer"  @click="onSubmit">提交</div>
                            <div class="button-right pointer">重置</div>
                            <div></div>
                        </div>
                        </el-row>

                        <!-- <el-button type="danger" @click="onSubmit" >提交</el-button>
                            <el-button  type="danger" plain>重置</el-button> -->
                        <!-- <el-row type="flex" class="row-bg" justify="end"> -->
                        <!-- <el-col :span="12" :offset="6">
                            <el-button type="danger" @click="onSubmit" >提交</el-button>
                            <el-button  type="danger" plain>重置</el-button>
                            </el-col> -->
                        
                    </el-form-item>
                    </el-form>
                </div>
                <div class="message-box-right">
                    <div class="contact">
                    <div class="contact-img"><img src="../../assets/home/base/map.png" alt=""></div>
                    <div class="contact-top flex-align-center">
                        <p>联系我们</p>
                    </div>
                    <div class="contact-bottom flex-evenly">
                        <p><img src="../../assets/home/icon/phone.png" alt=""></p>
                        <p>
                        张老师
                        <br>
                        13718568030（微信同号）
                        <br>
                        yd@lezhireading.com
                        <br>
                        010-88512948
                        </p>
                    
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
         <footer-view></footer-view>
  </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
            name: '',
            phone: '',
            address: '',
            comment: ''
            }
        }
    },
   
    methods: {
            onSubmit() {
       if(!this.form.name) {
         this.$message.error('请填写姓名。');
         return
       }
       if(!this.form.phone) {
         this.$message.error('请填写正确的手机号码。');
         return
       }
       if(!this.form.address) {
         this.$message.error('请填写邮箱账号。');
         return
       }
       if(!this.form.comment) {
         this.$message.error('请填写留言信息。');
         return
       }
       let params = {
          name:this.form.name,
          phone:this.form.phone ,
          address: this.form.address,
          comment: this.form.comment
        }
        Api.Home.getComment(this.form).then((result) => {
          console.log(result)
          if(result.code == 200) {
            this.$notify({
              title: '成功',
              message: result.msg,
              type: 'success'
            });
          }
        }).catch((err) => {
          console.log(err)
        });
      }
    },
    mounted(){
    },

}
</script>

<style lang="less" scoped>
    @import "./less/news_headlines_detail.less";
    .groupdetial-wrapper{
        margin:0 auto;
        margin-bottom: 150px;
        padding: 40px;
        width: 1200px;
        background-color: #fff;
    .message {
      padding: 30px 0;
      .message-top {
        p:nth-child(1) {
          // padding-top:40px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #666666;
        }
        p:nth-child(2) {
          width: 200px;
          background: #ececec;
          height: 1px;
          margin: 20px 0;
          // border: 1px solid #666666;
          // position: relative;
          span {
            // position: ;
            display: inline-block;
            width: 44px;
            height: 6px;
            background: #cc4c4d;
          }
        }
      }
      .message-box {
        .message-box-left {
          flex: 2;
            .el-input__inner:focus,
            .el-textarea .el-el-textarea__inner:focus {
              border-color: #dcdfe6;
            }
            .button {
              display: flex;
              .button-left  {
                text-align: center;
                background: #cc4c4d;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 34px;
                width: 130px;
              }
              .button-right {
                margin-left:30px;
                width: 130px;
                text-align: center;

                background: #FFFFFF;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                line-height: 33px;
                border: 1px solid #c9c9c9;
              }
            }
                  
        }
        .message-box-right {
          flex: 1;
          padding:20px 15px;
          margin-left:50px;
            border: 1px solid #E6E6E6;
            border-radius: 10px;
          .contact {
            width: 284px;
            .contact-img {
              padding:0 0 10px 0;
              img {
                width: 368px;
                height: 169px;
              }
            }
            .contact-top {
              background-image: url("../../assets/home/base/ban.png");
              background-repeat: no-repeat;
              height: 61px;
              width: 368px;
              background-size:cover;
              background-position: 50% 0;
              p {
                // text-align: center;
                // padding-left:20px;
                font-size: 22px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 30px;
                cursor: pointer;
              }
            }
            .contact-bottom{
              cursor: pointer;
              padding-top:30px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #bcbcbc;
              line-height: 30px;
            }
          }
        }
              
      }
    }
}

</style>